import defaultVert from "./default-vert.glsl";
import defaultFrag from "./default-frag.glsl";
import blitCopy from "./blit-copy.glsl";
import colorFrag from "./color-frag.glsl";
import colorVert from "./color-vert.glsl";
import flipVert from "./flip-vert.glsl";
import texFrag from "./tex-frag.glsl";

export const BuiltinShaderSources = {
    defaultVert,
    defaultFrag,
    blitCopy,
    colorFrag,
    colorVert,
    flipVert,
    texFrag,
};